/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'

import {addItemSuccess, deleteItemSuccess, error, updateItemSuccess,} from '@/utils/notification'
import {
  CREATE_CAMPUS,
  CREATE_CURRICULUM,
  CREATE_CURRICULUM_EXTERNAL,
  CREATE_DEBT_RESTRUCTURE_POLICY,
  CREATE_DEGREE,
  CREATE_EDUCATION_STATUS,
  CREATE_FACULTY,
  CREATE_MEASURE,
  CREATE_NATIONALITY,
  CREATE_NOTIFICATION_TEMPLATE,
  CREATE_OCCUPATION,
  CREATE_PERIOD,
  CREATE_PREFIX,
  CREATE_PROJECT,
  CREATE_RACE,
  CREATE_RELATIONSHIP,
  CREATE_RELIGION,
  CREATE_SIGNER,
  CREATE_SUB_MEASURE,
  DELETE_CAMPUS,
  DELETE_CURRICULUM,
  DELETE_CURRICULUM_EXTERNAL,
  DELETE_DEBT_RESTRUCTURE_POLICY,
  DELETE_DEGREE,
  DELETE_EDUCATION_STATUS,
  DELETE_FACULTY,
  DELETE_MEASURE,
  DELETE_NATIONALITY,
  DELETE_NOTIFICATION_TEMPLATE,
  DELETE_OCCUPATION,
  DELETE_PERIOD,
  DELETE_PREFIX,
  DELETE_PROJECT,
  DELETE_RACE,
  DELETE_RELATIONSHIP,
  DELETE_RELIGION,
  DELETE_SIGNER,
  DELETE_SUB_MEASURE,
  GET_CAMPUS,
  GET_CAMPUSES,
  GET_CAMPUSES_OPTIONS,
  GET_CURRICULUM,
  GET_CURRICULUM_EXTERNAL,
  GET_CURRICULUM_EXTERNALS,
  GET_CURRICULUM_EXTERNALS_ODER_BY_SET_CURRICULUM,
  GET_CURRICULUM_OPTIONS,
  GET_CURRICULUMS,
  GET_DEBT_RESTRUCTURE_POLICIES,
  GET_DEBT_RESTRUCTURE_POLICY,
  GET_DEGREE,
  GET_DEGREE_OPTIONS,
  GET_DEGREES,
  GET_EDUCATION_STATUS,
  GET_FACULTIES,
  GET_FACULTY,
  GET_MEASURE,
  GET_MEASURES,
  GET_NATIONALITIES,
  GET_NATIONALITY,
  GET_NOTIFICATION_TEMPLATE,
  GET_NOTIFICATION_TEMPLATE_OPTIONS,
  GET_NOTIFICATION_TEMPLATES,
  GET_OCCUPATION,
  GET_OCCUPATIONS,
  GET_PERIOD,
  GET_PERIODS,
  GET_PREFIX,
  GET_PREFIX_OPTIONS,
  GET_PREFIXES,
  GET_PROJECT,
  GET_PROJECTS,
  GET_PROJECTS_OPTIONS,
  GET_RACE,
  GET_RACES,
  GET_RELATIONSHIP,
  GET_RELATIONSHIP_OPTIONS,
  GET_RELATIONSHIPS,
  GET_RELIGION,
  GET_RELIGIONS,
  GET_SEARCH_CURRICULUMS,
  GET_SEARCH_PROJECTS,
  GET_SIGNER,
  GET_SIGNER_OPTIONS,
  GET_SIGNERS,
  GET_SUB_MEASURE,
  GET_SUB_MEASURES,
  UPDATE_CAMPUS,
  UPDATE_CURRICULUM,
  UPDATE_CURRICULUM_EXTERNAL,
  UPDATE_CURRICULUM_EXTERNAL_API,
  UPDATE_DEBT_RESTRUCTURE_POLICY,
  UPDATE_DEGREE,
  UPDATE_EDUCATION_STATUS,
  UPDATE_FACULTY,
  UPDATE_MEASURE,
  UPDATE_NATIONALITY,
  UPDATE_NOTIFICATION_TEMPLATE,
  UPDATE_OCCUPATION,
  UPDATE_PERIOD,
  UPDATE_PREFIX,
  UPDATE_PROJECT,
  UPDATE_RACE,
  UPDATE_RELATIONSHIP,
  UPDATE_RELIGION,
  UPDATE_SET_DEFAULT_MASTER,
  UPDATE_SIGNER,
  UPDATE_SUB_MEASURE,
  GET_SUB_MEASURES_OPTIONS,
} from '@/queries/modules/master'

export async function getPeriod(context, payload) {
  // console.log('Get Period...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PERIOD,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setPeriod', data.getPeriod)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPeriods(context, payload) {
  // console.log('Get Periods...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PERIODS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    context.commit('setPeriods', data.getPeriods)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPeriod(context, payload) {
  // console.log('Add Period...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PERIOD,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updatePeriod(context, payload) {
  // console.log('Update Period...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PERIOD,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deletePeriod(context, payload) {
  // console.log('Delete Period...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PERIOD,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delPeriod', data.deletePeriod)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getDegree(context, payload) {
  // console.log('Get Degree...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_DEGREE,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setDegree', data.getDegree)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getDegrees(context, payload) {
  // console.log('Get Degrees...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_DEGREES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setDegrees', data.getDegrees)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getDegreeOptions(context) {
  // console.log('Get Degree Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_DEGREE_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getDegrees: degreeOptions} = data;

    context.commit('setDegreeOptions', degreeOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createDegree(context, payload) {
  // console.log('Add Degree...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_DEGREE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateDegree(context, payload) {
  // console.log('Update Degree...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_DEGREE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteDegree(context, payload) {
  // console.log('Delete Degree...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_DEGREE,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delDegree', data.deleteDegree)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getProject(context, payload) {
  // console.log('Get Project...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PROJECT,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setProject', data.getProject)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProjects(context, payload) {
  // console.log('Get Projects...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PROJECTS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getProjects: projects} = await data
    context.commit('setProjects', projects)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getProjectOptions(context) {
  // console.log('Get Project Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_PROJECTS_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getProjects: projectOptions} = data;

    context.commit('setProjectOptions', projectOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSearchProjects(context, payload) {
  // console.log('Get Projects...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SEARCH_PROJECTS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getProjects: projects} = await data

    context.commit('setProjects', projects)
    context.commit('setProjectOptions', projects)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createProject(context, payload) {
  // console.log('Add Project...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PROJECT,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateProject(context, payload) {
  // console.log('Update Project...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PROJECT,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteProject(context, payload) {
  // console.log('Delete Project...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PROJECT,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delProject', data.deleteProject)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getCampus(context, payload) {
  // console.log('Get Campus...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_CAMPUS,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data: {getCampus: campus}} = await response

    context.commit('setCampus', campus)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCampuses(context, payload) {
  // console.log('Get Campuses...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CAMPUSES,
        fetchPolicy: 'network-only'
      })

    const {data: {getCampuses: campuses}} = await response

    context.commit('setCampuses', campuses)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCampusOptions(context) {
  // console.log('Get Campus Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_CAMPUSES_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getCampuses: campusOptions} = data;

    context.commit('setCampusOptions', campusOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createCampus(context, payload) {
  // console.log('Add Campus...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CAMPUS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateCampus(context, payload) {
  // console.log('Update Campus...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CAMPUS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteCampus(context, payload) {
  // console.log('Delete Campus...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_CAMPUS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data: {deleteCampus: campus}} = await response

    context.commit('delCampus', campus)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getFaculty(context, payload) {
  // console.log('Get Faculty...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_FACULTY,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFaculty', data.getFaculty)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getFaculties(context, payload) {
  // console.log('Get Faculties...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_FACULTIES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setFaculties', data.getFaculties)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createFaculty(context, payload) {
  // console.log('Add Faculty...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_FACULTY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateFaculty(context, payload) {
  // console.log('Update Faculty...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_FACULTY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteFaculty(context, payload) {
  // console.log('Delete Faculty...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_FACULTY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delFaculty', data.deleteFaculty)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getCurriculum(context, payload) {
  // console.log('Get Curriculum...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_CURRICULUM,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setCurriculum', data.getCurriculum)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCurriculums(context, payload) {
  // console.log('Get Curriculums...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CURRICULUMS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getCurriculums: curriculums} = await data

    context.commit('setCurriculums', curriculums)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCurriculumOptions(context) {
  // console.log('Get Curriculum Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_CURRICULUM_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getCurriculums: curriculumOptions} = data;

    context.commit('setCurriculumOptions', curriculumOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSearchCurriculums(context, payload) {
  // console.log('Get Curriculums...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SEARCH_CURRICULUMS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getCurriculums: curriculums} = await data

    context.commit('setCurriculums', curriculums)
    context.commit('setCurriculumOptions', curriculums)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createCurriculum(context, payload) {
  // console.log('Add Curriculum...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CURRICULUM,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response


    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    } else {
      const {createCurriculum} = await data
      return createCurriculum.id;
    }
  } catch (e) {
    //console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateCurriculum(context, payload) {
  // console.log('Update Curriculum...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CURRICULUM,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteCurriculum(context, payload) {
  // console.log('Delete Curriculum...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_CURRICULUM,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delCurriculum', data.deleteCurriculum)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getCurriculumExternal(context, payload) {
  // console.log('Get CurriculumExternal...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_CURRICULUM_EXTERNAL,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getCurriculumExternal} = await data

    context.commit('setCurriculumExternal', getCurriculumExternal)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCurriculumExternals(context, payload) {
  // console.log('Get CurriculumExternals...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CURRICULUM_EXTERNALS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getCurriculumExternals} = await data

    context.commit('setCurriculumExternals', getCurriculumExternals)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getCurriculumExternalsEnabled(context, payload) {
  // console.log('Get CurriculumExternals...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_CURRICULUM_EXTERNALS_ODER_BY_SET_CURRICULUM,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getCurriculumExternalsEnabled} = await data

    context.commit('setCurriculumExternals', getCurriculumExternalsEnabled)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createCurriculumExternal(context, payload) {
  // console.log('Add CurriculumExternal...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_CURRICULUM_EXTERNAL,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    //console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateCurriculumExternal(context, payload) {
  // console.log('Update CurriculumExternal...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }
  // console.log(variables)
  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CURRICULUM_EXTERNAL,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateCurriculumExternalApi(context, payload) {
  // console.log('Update CurriculumExternalApi...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CURRICULUM_EXTERNAL_API,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteCurriculumExternal(context, payload) {
  // console.log('Delete CurriculumExternal...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_CURRICULUM_EXTERNAL,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {deleteCurriculumExternal} = await data

    context.commit('delCurriculumExternal', deleteCurriculumExternal)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getPrefix(context, payload) {
  // console.log('Get Prefix...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_PREFIX,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setPrefix', data.getPrefix)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPrefixes(context, payload) {
  // console.log('Get Prefixes...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PREFIXES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setPrefixes', data.getPrefixes)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getPrefixOptions(context) {
  // console.log('Get Prefix Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_PREFIX_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getPrefixes: prefixOptions} = data;

    context.commit('setPrefixOptions', prefixOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createPrefix(context, payload) {
  // console.log('Add Prefix...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PREFIX,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updatePrefix(context, payload) {
  // console.log('Update Prefix...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_PREFIX,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deletePrefix(context, payload) {
  // console.log('Delete Prefix...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_PREFIX,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delPrefix', data.deletePrefix)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getRelationship(context, payload) {
  // console.log('Get Relationship...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_RELATIONSHIP,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setRelationship', data.getRelationship)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getRelationshipOptions(context) {
  // console.log('Get Relationship Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_RELATIONSHIP_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getRelationships: relationshipOptions} = data;

    context.commit('setRelationshipOptions', relationshipOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getRelationships(context, payload) {
  // console.log('Get Relationships...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_RELATIONSHIPS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setRelationships', data.getRelationships)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createRelationship(context, payload) {
  // console.log('Add Relationship...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_RELATIONSHIP,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateRelationship(context, payload) {
  // console.log('Update Relationship...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_RELATIONSHIP,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteRelationship(context, payload) {
  // console.log('Delete Relationship...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_RELATIONSHIP,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delRelationship', data.deleteRelationship)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getNationality(context, payload) {
  // console.log('Get Nationality...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_NATIONALITY,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setNationality', data.getNationality)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNationalities(context, payload) {
  // console.log('Get Nationalities...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_NATIONALITIES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setNationalities', data.getNationalities)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createNationality(context, payload) {
  // console.log('Add Nationality...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_NATIONALITY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateNationality(context, payload) {
  // console.log('Update Nationality...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_NATIONALITY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteNationality(context, payload) {
  // console.log('Delete Nationality...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_NATIONALITY,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delNationality', data.deleteNationality)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getRace(context, payload) {
  // console.log('Get Race...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_RACE,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setRace', data.getRace)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getRaces(context, payload) {
  // console.log('Get Races...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_RACES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setRaces', data.getRaces)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createRace(context, payload) {
  // console.log('Add Race...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_RACE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateRace(context, payload) {
  // console.log('Update Race...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_RACE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteRace(context, payload) {
  // console.log('Delete Race...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_RACE,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delRace', data.deleteRace)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getReligion(context, payload) {
  // console.log('Get Religion...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_RELIGION,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setReligion', data.getReligion)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getReligions(context, payload) {
  // console.log('Get Religions...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_RELIGIONS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setReligions', data.getReligions)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createReligion(context, payload) {
  // console.log('Add Religion...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_RELIGION,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateReligion(context, payload) {
  // console.log('Update Religion...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_RELIGION,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteReligion(context, payload) {
  // console.log('Delete Religion...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_RELIGION,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delReligion', data.deleteReligion)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getOccupation(context, payload) {
  // console.log('Get Occupation...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_OCCUPATION,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setOccupation', data.getOccupation)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getOccupations(context, payload) {
  // console.log('Get Occupations...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_OCCUPATIONS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setOccupations', data.getOccupations)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createOccupation(context, payload) {
  // console.log('Add Occupation...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_OCCUPATION,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateOccupation(context, payload) {
  // console.log('Update Occupation...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_OCCUPATION,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteOccupation(context, payload) {
  // console.log('Delete Occupation...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_OCCUPATION,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delOccupation', data.deleteOccupation)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getSigner(context, payload) {
  // console.log('Get Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_SIGNER,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setSigner', data.getSigner)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSigners(context, payload) {
  // console.log('Get Signers...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SIGNERS,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setSigners', data.getSigners)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getSignerOptions(context) {
  // console.log('Get Project Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_SIGNER_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getSigners: signerOptions} = data;

    context.commit('setSignerOptions', signerOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createSigner(context, payload) {
  // console.log('Add Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_SIGNER,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    //console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateSigner(context, payload) {
  // console.log('Update Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_SIGNER,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteSigner(context, payload) {
  // console.log('Delete Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_SIGNER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delSigner', data.deleteSigner)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getNotificationTemplate(context, payload) {
  // console.log('Get NotificationTemplate...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_TEMPLATE,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getNotificationTemplate: notificationTemplate} = data

    context.commit('setNotificationTemplate', notificationTemplate)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationTemplates(context, payload) {
  // console.log('Get NotificationTemplates...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_TEMPLATES,
        fetchPolicy: 'network-only'
      })

    const {data} = await response
    const {getNotificationTemplates: notificationTemplates} = data
    // console.log("notificationTemplates", notificationTemplates)

    context.commit('setNotificationTemplates', notificationTemplates)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getNotificationTemplateOptions(context) {
  // console.log('Get NotificationTemplate Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_NOTIFICATION_TEMPLATE_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getNotificationTemplates: notificationTemplateOptions} = data;

    context.commit('setNotificationTemplateOptions', notificationTemplateOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createNotificationTemplate(context, payload) {
  // console.log('Add NotificationTemplate...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_NOTIFICATION_TEMPLATE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateNotificationTemplate(context, payload) {
  // console.log('Update NotificationTemplate...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_NOTIFICATION_TEMPLATE,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteNotificationTemplate(context, payload) {
  // console.log('Delete NotificationTemplate...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_NOTIFICATION_TEMPLATE,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {deleteNotificationTemplate: notificationTemplate} = data

    context.commit('delNotificationTemplate', notificationTemplate)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getEducationStatus(context, payload) {
  // console.log('Get EducationStatus...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_EDUCATION_STATUS,
        variables,
        fetchPolicy: 'network-only'
      })

    const {data} = await response

    context.commit('setEducationStatus', data.getEducationStatus)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createEducationStatus(context, payload) {
  // console.log('Add EducationStatus...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_EDUCATION_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateEducationStatus(context, payload) {
  // console.log('Update EducationStatus...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_EDUCATION_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect != null) {
      setTimeout(() => {
        payload.vm.$router.push(payload.redirect)
      }, 200);
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function deleteEducationStatus(context, payload) {
  // console.log('Delete EducationStatus...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_EDUCATION_STATUS,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response

    context.commit('delEducationStatus', data.deleteEducationStatus)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function updateSetDefaultMaster(context, payload) {
  // console.log('Update Set Default Master...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_SET_DEFAULT_MASTER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function setPaymentFilters(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setPaymentFilters', payload);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function setTransactionFilters(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setTransactionFilters', payload);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function onChangeYears(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);

  try {
    context.commit('setSuccess', null);
    context.commit('setYearsSelected', payload);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getDebtRestructurePolicy(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }
    const response = await apolloClient
      .query({
        query: GET_DEBT_RESTRUCTURE_POLICY,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getDebtRestructurePolicy} = data

    context.commit('setDebtRestructurePolicy', getDebtRestructurePolicy)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getDebtRestructurePolicies(context) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient.query({
      query: GET_DEBT_RESTRUCTURE_POLICIES,
      fetchPolicy: 'network-only'
    })
    const {data: {getDebtRestructurePolicies: policies}} = await response
    context.commit('setDebtRestructurePolicies', policies)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function createDebtRestructurePolicy(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {payload: payload.form}
    await apolloClient.mutate({
      mutation: CREATE_DEBT_RESTRUCTURE_POLICY,
      variables,
      fetchPolicy: 'no-cache'
    })
    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function updateDebtRestructurePolicy(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.id, payload: payload.form}
    // console.log("variables", variables)
    await apolloClient.mutate({
      mutation: UPDATE_DEBT_RESTRUCTURE_POLICY,
      variables,
      fetchPolicy: 'no-cache'
    })

    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function deleteDebtRestructurePolicy(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.form.id}
    const response = await apolloClient.mutate({
      mutation: DELETE_DEBT_RESTRUCTURE_POLICY,
      variables,
      fetchPolicy: 'no-cache'
    })
    const {data: {deleteDebtRestructurePolicy: policy}} = await response
    context.commit('delDebtRestructurePolicy', policy)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function getMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.form.id}
    const response = await apolloClient.query({
      query: GET_MEASURE,
      variables,
      fetchPolicy: 'network-only'
    })
    const {data: {getMeasure: measure}} = await response
    context.commit('setMeasure', measure)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getMeasures(context) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient.query({
      query: GET_MEASURES,
      fetchPolicy: 'network-only'
    })
    const {data: {getMeasures: measures}} = await response
    context.commit('setMeasures', measures)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function createMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {payload: payload.form}
    await apolloClient.mutate({
      mutation: CREATE_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function updateMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.id, payload: payload.form}
    await apolloClient.mutate({
      mutation: UPDATE_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function deleteMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.form.id}
    const response = await apolloClient.mutate({
      mutation: DELETE_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    const {data: {deleteMeasure: measure}} = await response
    context.commit('delMeasure', measure)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function getSubMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.form.id}
    const response = await apolloClient.query({
      query: GET_SUB_MEASURE,
      variables,
      fetchPolicy: 'network-only'
    })
    const {data: {getSubMeasure: subMeasure}} = await response
    context.commit('setSubMeasure', subMeasure)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getSubMeasures(context) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient.query({
      query: GET_SUB_MEASURES,
      fetchPolicy: 'network-only'
    })
    const {data: {getSubMeasures: subMeasures}} = await response
    context.commit('setSubMeasures', subMeasures)
    context.commit('setSuccess', null)
  } catch (e) {
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getSubMeasureOptions(context) {
  // console.log('Get Campus Options...');

  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const response = await apolloClient
      .query({
        query: GET_SUB_MEASURES_OPTIONS,
        fetchPolicy: 'network-only'
      });

    const {data} = await response;
    const {getSubMeasures: subMeasureOptions} = data;

    context.commit('setSubMeasureOptions', subMeasureOptions);
    context.commit('setSuccess', null);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createSubMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {payload: payload.form}
    await apolloClient.mutate({
      mutation: CREATE_SUB_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    context.commit('setSuccess', addItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function updateSubMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.id, payload: payload.form}
    await apolloClient.mutate({
      mutation: UPDATE_SUB_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    context.commit('setSuccess', updateItemSuccess({}))
    if (payload.redirect) {
      setTimeout(() => payload.vm.$router.push(payload.redirect), 200)
    }
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

export async function deleteSubMeasure(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {id: payload.form.id}
    const response = await apolloClient.mutate({
      mutation: DELETE_SUB_MEASURE,
      variables,
      fetchPolicy: 'no-cache'
    })
    const {data: {deleteSubMeasure: subMeasure}} = await response
    context.commit('delSubMeasure', subMeasure)
    context.commit('setSuccess', deleteItemSuccess({}))
  } catch (e) {
    context.commit('setError', error(null, null))
  }
}

